var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","display":"flex","padding":"10px"}},[_c('img',{attrs:{"src":require("../assets/logo_color.png"),"width":"120px"}})])
}]

export { render, staticRenderFns }